import { cn } from '../../../lib/utils.ts'
import { type IllustrationProps } from '../illustration-base.tsx'
import { illustrationVariants } from '../illustration.variants.ts'

export function GuideBookIllustration({
  size = 'big',
  className,
  'aria-label': ariaLabel = 'Guide book',
  'aria-hidden': ariaHidden,
  ...rest
}: IllustrationProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 80 80"
      role="img"
      aria-label={ariaHidden === true ? undefined : ariaLabel}
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      className={cn(illustrationVariants({ size }), className)}
      {...rest}
    >
      <>
        <defs>
          <linearGradient
            id="guide-book-paint0_linear_16538_41536"
            x1={25.462}
            x2={25.462}
            y1={42.271}
            y2={10.019}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#58B558" />
            <stop offset={0.1} stopColor="#68BF68" />
            <stop offset={0.36} stopColor="#8CD68C" />
            <stop offset={0.61} stopColor="#A5E7A5" />
            <stop offset={0.83} stopColor="#B5F1B5" />
            <stop offset={1} stopColor="#BBF5BB" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint1_linear_16538_41536"
            x1={33.217}
            x2={55.925}
            y1={36.69}
            y2={65.469}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D46353" />
            <stop offset={0.21} stopColor="#D1644E" />
            <stop offset={0.53} stopColor="#C85841" />
            <stop offset={0.91} stopColor="#BB3E25" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint2_linear_16538_41536"
            x1={5.482}
            x2={78.055}
            y1={47.047}
            y2={47.047}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC8F7C" />
            <stop offset={0.25} stopColor="#E88976" />
            <stop offset={0.64} stopColor="#DF7A66" />
            <stop offset={1} stopColor="#D46953" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint3_linear_16538_41536"
            x1={9.842}
            x2={48.345}
            y1={53.199}
            y2={49.003}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F7F2F0" />
            <stop offset={0.61} stopColor="#E7DDD3" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint4_linear_16538_41536"
            x1={70.141}
            x2={46.233}
            y1={31.078}
            y2={42.235}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F7F2F0" />
            <stop offset={0.29} stopColor="#F4EEEA" />
            <stop offset={0.64} stopColor="#ECE3DC" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint5_linear_16538_41536"
            x1={35.339}
            x2={20.284}
            y1={66.158}
            y2={56.019}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0906B" />
            <stop offset={0.19} stopColor="#B29370" />
            <stop offset={0.41} stopColor="#BA9E7E" />
            <stop offset={0.66} stopColor="#C7B096" />
            <stop offset={0.91} stopColor="#D8C9B8" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint6_linear_16538_41536"
            x1={66.733}
            x2={50.352}
            y1={24.704}
            y2={40.557}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F7F2F0" />
            <stop offset={0.29} stopColor="#F4EEEA" />
            <stop offset={0.64} stopColor="#ECE3DC" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint7_linear_16538_41536"
            x1={61.845}
            x2={47.153}
            y1={25.843}
            y2={42.111}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F7F2F0" />
            <stop offset={0.33} stopColor="#F1EBE6" />
            <stop offset={0.87} stopColor="#E4D9CD" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint8_linear_16538_41536"
            x1={57.446}
            x2={39.637}
            y1={25.315}
            y2={49.05}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={0.3} stopColor="#FDFCFB" />
            <stop offset={0.54} stopColor="#F7F4F1" />
            <stop offset={0.77} stopColor="#EEE7E0" />
            <stop offset={0.98} stopColor="#E1D5C8" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint9_linear_16538_41536"
            x1={15.941}
            x2={40.036}
            y1={49.775}
            y2={48.596}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F7F2F0" />
            <stop offset={0.3} stopColor="#F4EEEB" />
            <stop offset={0.62} stopColor="#EDE5DE" />
            <stop offset={0.95} stopColor="#E2D6C9" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint10_linear_16538_41536"
            x1={14.409}
            x2={50.191}
            y1={43.498}
            y2={52.329}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={0.26} stopColor="#FCFBFA" />
            <stop offset={0.53} stopColor="#F5F2ED" />
            <stop offset={0.81} stopColor="#EAE2D8" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint11_linear_16538_41536"
            x1={30.352}
            x2={39.013}
            y1={50.337}
            y2={41.494}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={0.29} stopColor="#F8F6F3" />
            <stop offset={0.8} stopColor="#E7DED3" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
          <linearGradient
            id="guide-book-paint12_linear_16538_41536"
            x1={52.628}
            x2={54.465}
            y1={48.442}
            y2={52.374}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B0906B" />
            <stop offset={0.19} stopColor="#B29370" />
            <stop offset={0.41} stopColor="#BA9E7E" />
            <stop offset={0.66} stopColor="#C7B096" />
            <stop offset={0.91} stopColor="#D8C9B8" />
            <stop offset={1} stopColor="#E0D4C6" />
          </linearGradient>
        </defs>
        <g id="guide-book-Insurance=-, Generic=Guide book, Size=Big">
          <g id="guide-book-Group 233">
            <path
              id="guide-book-Vector"
              fill="#000"
              d="m25.433 14.059-2.126-.28a.92.92 0 0 0-.797.298L11.664 25.81c-.171.187-.088.503.146.568l2.635.717 10.98-13.033z"
            />
            <path
              id="guide-book-Vector_2"
              fill="#000"
              d="M14.47 27.296s-.027 0-.039-.006l-2.642-.72a.47.47 0 0 1-.327-.33.5.5 0 0 1 .113-.483L22.447 13.99c.24-.26.585-.388.927-.343l2.131.28a.14.14 0 0 1 .119.096.15.15 0 0 1-.024.149l-11.008 13.07a.16.16 0 0 1-.113.054zm8.759-13.36a.78.78 0 0 0-.571.257L11.786 25.959a.2.2 0 0 0-.044.197c.008.03.038.105.118.126l2.554.691 10.77-12.79-1.86-.244a1 1 0 0 0-.098-.006z"
            />
            <path
              id="guide-book-Vector_3"
              fill="url(#guide-book-paint0_linear_16538_41536)"
              d="m36.708 24.841-10.81-10.56a.59.59 0 0 0-.87.035L14.203 26.59c-.193.22-.036.58.247.56l4.947-.387V44.97l11.675-.916V25.847l5.455-.428c.27-.021.386-.381.184-.575z"
            />
            <path
              id="guide-book-Vector_4"
              fill="#000"
              d="M19.42 45.104a.16.16 0 0 1-.1-.039.15.15 0 0 1-.048-.11V26.888l-4.797.375a.43.43 0 0 1-.437-.256.5.5 0 0 1 .068-.551l10.846-12.29c.14-.159.33-.251.535-.26a.75.75 0 0 1 .551.215l10.83 10.574a.5.5 0 0 1 .117.524.45.45 0 0 1-.393.307l-5.329.417v18.091a.15.15 0 0 1-.137.15L19.43 45.1h-.012zm0-18.526c.036 0 .075.015.101.038a.15.15 0 0 1 .048.11v18.068l11.4-.894V25.81a.15.15 0 0 1 .136-.149l5.466-.429c.09-.006.125-.08.137-.113a.2.2 0 0 0-.044-.209L25.833 14.335a.43.43 0 0 0-.334-.131.46.46 0 0 0-.324.158L14.33 26.652c-.065.072-.053.164-.027.22.015.03.057.099.15.093l4.957-.387z"
            />
            <path id="guide-book-Vector_5" fill="#000" d="m19.408 44.903-2.611-.697V26.95l2.61-.19z" />
            <path
              id="guide-book-Vector_6"
              fill="#000"
              d="M19.393 45.104s-.027 0-.039-.006l-2.583-.7a.15.15 0 0 1-.11-.144V26.9c0-.078.06-.144.137-.15l2.583-.19a.16.16 0 0 1 .112.038c.03.027.048.069.048.11v18.244a.147.147 0 0 1-.148.15zm-2.438-.963 2.287.62V26.873l-2.287.167z"
            />
            <g id="guide-book-Group" fill="#000" opacity={0.1}>
              <path
                id="guide-book-Vector_7"
                d="M74.558 43.414 46.322 29.31 1.952 51.475v1.008l28.236 14.104L50.359 56.51c.41.916 1.624 1.22 2.734.672 1.115-.55 1.692-1.751 1.297-2.686l20.168-10.075z"
              />
              <path
                id="guide-book-Vector_8"
                d="M30.188 66.735a.2.2 0 0 1-.066-.015L1.887 52.617a.15.15 0 0 1-.084-.133v-1.009c0-.056.033-.107.084-.134l44.37-22.164a.15.15 0 0 1 .134 0L74.627 43.28c.05.024.083.077.083.134v1.008a.15.15 0 0 1-.083.134l-20.05 10.016c.322.984-.288 2.19-1.419 2.745-.639.316-1.341.375-1.933.161a1.72 1.72 0 0 1-.931-.767L30.256 66.72a.13.13 0 0 1-.065.014zM2.101 52.391l28.087 14.032L50.291 56.38a.14.14 0 0 1 .116-.006.15.15 0 0 1 .086.08c.158.352.443.61.83.75.515.185 1.133.131 1.699-.148 1.04-.515 1.591-1.634 1.225-2.496a.15.15 0 0 1 .072-.19l20.088-10.034v-.824L46.32 29.48 2.098 51.57v.824z"
              />
            </g>
            <g id="guide-book-Group_2" fill="#000" opacity={0.1}>
              <path
                id="guide-book-Vector_9"
                d="M31.092 30.147c-2.529 2.826-3.998 5.899-4.7 8.29a17 17 0 0 0-6.994-1.514v5.078l5.081 2.538 6.613-.518V30.147"
              />
              <path
                id="guide-book-Vector_10"
                d="M24.48 44.684a.2.2 0 0 1-.066-.015l-5.08-2.537a.15.15 0 0 1-.084-.134V36.92c0-.083.065-.149.148-.149 2.362 0 4.683.491 6.899 1.46.53-1.745 1.82-4.985 4.682-8.185a.149.149 0 0 1 .259.101v13.87a.15.15 0 0 1-.137.15l-6.613.517h-.012zm-4.93-2.778 4.959 2.478 6.434-.503V30.542c-2.73 3.16-3.93 6.313-4.408 7.94a.15.15 0 0 1-.08.092.14.14 0 0 1-.122 0 16.9 16.9 0 0 0-6.783-1.502v4.837z"
              />
            </g>
            <path
              id="guide-book-Vector_11"
              fill="url(#guide-book-paint1_linear_16538_41536)"
              d="M78.055 43.011 49.832 28.902 5.482 51.076v1.008l28.223 14.11 20.162-10.08c.41.916 1.624 1.22 2.733.672 1.115-.55 1.691-1.753 1.296-2.687l20.16-10.08z"
            />
            <path
              id="guide-book-Vector_12"
              fill="url(#guide-book-paint2_linear_16538_41536)"
              d="m78.055 43.015-44.35 22.174-28.223-14.11 44.35-22.177z"
            />
            <path
              id="guide-book-Vector_13"
              fill="#000"
              d="M33.733 66.327a.2.2 0 0 1-.065-.015L5.432 52.215a.15.15 0 0 1-.084-.134v-1.008c0-.056.033-.107.084-.134l44.37-22.155a.15.15 0 0 1 .135 0l28.236 14.097c.05.024.083.078.083.134v1.008a.15.15 0 0 1-.083.134l-20.05 10.012c.321.984-.288 2.188-1.419 2.744-.64.315-1.341.375-1.933.16a1.72 1.72 0 0 1-.931-.767L33.802 66.313a.13.13 0 0 1-.066.015zM5.646 51.99l28.087 14.023 20.104-10.038a.14.14 0 0 1 .115-.006.15.15 0 0 1 .087.08c.157.35.443.61.83.75.514.183 1.133.13 1.698-.15 1.041-.514 1.592-1.632 1.226-2.494a.15.15 0 0 1 .071-.19l20.089-10.03v-.824L49.865 29.084 5.643 51.168v.824z"
            />
            <path
              id="guide-book-Vector_14"
              fill="#000"
              d="m57.12 54.472-.345-.798-.006-.02L28.655 39.48l-2.485 1.244 28.09 14.189.357.803c.122.265.446.435.85.435.253 0 .517-.066.773-.188.735-.363 1.056-1.077.88-1.49"
            />
            <path
              id="guide-book-Vector_15"
              fill="#000"
              d="M55.517 56.285c-.461 0-.842-.2-.988-.52l-.337-.755-28.076-14.139a.15.15 0 0 1-.08-.133c0-.057.032-.107.083-.134l2.489-1.242a.15.15 0 0 1 .133 0L56.89 53.51a.15.15 0 0 1 .078.095l.342.793c.206.484-.13 1.275-.952 1.679a1.95 1.95 0 0 1-.84.202zM26.515 40.738l27.86 14.028c.029.015.053.042.068.072l.357.802c.16.35.84.454 1.423.172.693-.341.94-.986.81-1.298l-.334-.767L28.67 39.66l-2.158 1.076z"
            />
            <path id="guide-book-Vector_16" fill="#fff" d="m75.176 43.299-40.83 20.417-25.985-12.99 40.833-20.417z" />
            <path
              id="guide-book-Vector_17"
              fill="#000"
              d="M34.335 63.917a.2.2 0 0 1-.066-.015L8.243 50.897a.15.15 0 0 1 0-.268L49.137 30.19a.15.15 0 0 1 .134 0l26.023 13.005a.149.149 0 0 1 0 .268L34.4 63.902a.13.13 0 0 1-.065.015M8.642 50.763l25.693 12.838 40.56-20.272-25.69-12.841L8.642 50.76z"
            />
            <path
              id="guide-book-Vector_18"
              fill="url(#guide-book-paint3_linear_16538_41536)"
              d="M8.361 49.745v1.007l1.008-.505 24.99 12.465 19.93-9.943-25.996-12.967c-5.309-2.174-15.36 3.81-19.932 9.943"
            />
            <path
              id="guide-book-Vector_19"
              fill="#000"
              d="M34.328 62.913a.2.2 0 0 1-.065-.015L9.32 50.413l-.944.471a.15.15 0 0 1-.217-.134v-1.01a.14.14 0 0 1 .03-.09c2.286-3.078 5.929-6.13 9.744-8.163 4.191-2.234 7.876-2.896 10.376-1.87L54.34 52.644a.15.15 0 0 1 0 .268l-19.945 9.986a.13.13 0 0 1-.066.015M9.318 50.094q.035 0 .065.015l24.942 12.484 19.612-9.818-25.752-12.89c-5.092-2.09-15.093 3.686-19.73 9.902v.719l.794-.397a.13.13 0 0 1 .066-.015z"
            />
            <path
              id="guide-book-Vector_20"
              fill="url(#guide-book-paint4_linear_16538_41536)"
              d="M49.207 29.304c-5.915.34-17.993 3.722-20.896 10.48l25.966 13.02 20.899-10.48-25.966-13.02z"
            />
            <path
              id="guide-book-Vector_21"
              fill="#000"
              d="M54.284 52.934a.2.2 0 0 1-.066-.015l-26.024-13a.15.15 0 0 1-.072-.194C31.043 32.95 43.29 29.507 49.195 29.17a.13.13 0 0 1 .075.015L75.294 42.19a.149.149 0 0 1 0 .268L54.349 52.922a.13.13 0 0 1-.066.015zM28.452 39.713l25.83 12.906L74.896 42.32 49.172 29.47c-5.809.342-17.757 3.686-20.719 10.244"
            />
            <path
              id="guide-book-Vector_22"
              fill="url(#guide-book-paint5_linear_16538_41536)"
              d="M8.361 49.724v1.008l25.976 12.984v-1.005z"
            />
            <path
              id="guide-book-Vector_23"
              fill="#000"
              d="M34.32 63.911a.2.2 0 0 1-.066-.015L8.244 50.882a.15.15 0 0 1-.084-.134v-1.01a.15.15 0 0 1 .217-.131l26.01 13.016a.15.15 0 0 1 .084.134v1.01c0 .052-.027.1-.071.126a.15.15 0 0 1-.078.024zM8.457 50.655 34.17 63.52v-.676L8.457 49.976v.679"
            />
            <path
              id="guide-book-Vector_24"
              fill="url(#guide-book-paint6_linear_16538_41536)"
              d="m28.245 39.809 26.003 12.994c.83-6.071 11.349-12.057 19.455-11.363L49.5 29.344c-9.817-1.086-20.44 6.346-21.255 10.465"
            />
            <path
              id="guide-book-Vector_25"
              fill="#E0D4C6"
              d="M54.283 52.934a.2.2 0 0 1-.066-.015L28.194 39.941a.15.15 0 0 1-.08-.16c.806-4.06 11.468-11.67 21.435-10.57a.1.1 0 0 1 .05.015l24.223 12.08a.15.15 0 0 1 .078.172.144.144 0 0 1-.155.107c-8.202-.701-18.495 5.276-19.31 11.221a.15.15 0 0 1-.078.113.14.14 0 0 1-.068.018zm-25.854-13.21L54.167 52.56c1.006-5.832 10.753-11.623 18.866-11.32L49.49 29.496c-9.727-1.055-20.102 6.227-21.06 10.225z"
            />
            <path
              id="guide-book-Vector_26"
              fill="url(#guide-book-paint7_linear_16538_41536)"
              d="m28.245 39.797 26.037 13.006c.831-6.077 9.196-13.232 17.748-13.468L47.795 27.23c-10.203.423-18.731 8.445-19.55 12.571z"
            />
            <path
              id="guide-book-Vector_27"
              fill="#E0D4C6"
              d="M54.28 52.934a.2.2 0 0 1-.065-.015L28.194 39.93a.15.15 0 0 1-.08-.16c.833-4.198 9.508-12.252 19.677-12.674q.038-.002.071.015l24.22 12.09c.063.03.093.099.078.167a.15.15 0 0 1-.14.116c-8.767.241-16.793 7.486-17.59 13.323a.15.15 0 0 1-.078.113.14.14 0 0 1-.069.018zM28.43 39.713l25.734 12.846c.95-5.783 8.693-12.82 17.272-13.35L47.765 27.39c-9.925.432-18.391 8.179-19.335 12.324"
            />
            <path
              id="guide-book-Vector_28"
              fill="url(#guide-book-paint8_linear_16538_41536)"
              d="m28.245 39.815 26.04 12.988c.832-6.069 9.144-15.056 14.33-15.85L44.13 24.684c-9.974 2.791-14.476 10.33-15.885 15.13"
            />
            <path
              id="guide-book-Vector_29"
              fill="#E0D4C6"
              d="M54.282 52.931a.2.2 0 0 1-.065-.015L28.194 39.913a.15.15 0 0 1-.078-.175c1.661-5.674 6.734-12.658 15.975-15.25a.17.17 0 0 1 .108.01L68.667 36.78c.057.03.09.092.08.158a.15.15 0 0 1-.124.125c-5.171.795-13.397 9.918-14.195 15.743a.15.15 0 0 1-.078.113.14.14 0 0 1-.068.018zM28.438 39.7l25.728 12.857c.956-5.885 8.66-14.495 13.978-15.707l-24.026-12.06c-9.026 2.553-14.007 9.35-15.68 14.913z"
            />
            <path
              id="guide-book-Vector_30"
              fill="url(#guide-book-paint9_linear_16538_41536)"
              d="m28.297 39.807 25.992 12.957s-10.084-2.28-19.391 5.998L10.705 46.7s9.26-9.284 17.592-6.895"
            />
            <path
              id="guide-book-Vector_31"
              fill="#E0D4C6"
              d="M34.864 58.963a.2.2 0 0 1-.066-.015L10.585 46.86a.15.15 0 0 1-.08-.11.14.14 0 0 1 .042-.128c.092-.095 9.425-9.339 17.752-6.947.009 0 .018.006.027.008L54.339 52.67a.15.15 0 0 1 .074.184.146.146 0 0 1-.172.096c-.101-.021-10.128-2.169-19.276 5.975a.15.15 0 0 1-.098.039zm-23.96-12.275L34.84 58.635c7.595-6.712 15.776-6.445 18.514-6.124l-25.15-12.557c-7.583-2.168-16.077 5.565-17.297 6.73z"
            />
            <path
              id="guide-book-Vector_32"
              fill="url(#guide-book-paint10_linear_16538_41536)"
              d="m28.276 39.766 26.012 13.015S46 49.249 36.254 56.084L12.043 43.969s6.306-7.074 16.233-4.206z"
            />
            <path
              id="guide-book-Vector_33"
              fill="#E0D4C6"
              d="M36.254 56.218a.2.2 0 0 1-.066-.015l-24.195-12.1a.15.15 0 0 1-.08-.104.15.15 0 0 1 .035-.128c.063-.072 6.48-7.101 16.374-4.243.01 0 .018.006.024.009l25.995 12.999a.15.15 0 0 1 .068.197.146.146 0 0 1-.193.074c-.02-.009-2.09-.872-5.317-.9-2.971-.02-7.569.686-12.562 4.184a.16.16 0 0 1-.086.027zM12.305 43.924l23.937 11.972c4.948-3.445 9.51-4.186 12.52-4.186h.157c1.55.012 2.826.211 3.75.423L28.228 39.908c-8.921-2.57-14.955 3.04-15.922 4.016"
            />
            <path
              id="guide-book-Vector_34"
              fill="url(#guide-book-paint11_linear_16538_41536)"
              d="m28.281 39.796 26.007 13.007s-7.492-4.227-15.828-.852L14.253 39.844s6.34-3.498 14.028-.048"
            />
            <path
              id="guide-book-Vector_35"
              fill="#E0D4C6"
              d="M54.274 52.937a.2.2 0 0 1-.065-.015l-.527-.261c-1.831-.857-8.241-3.389-15.169-.584a.15.15 0 0 1-.122-.005L14.201 39.98a.15.15 0 0 1-.006-.265c.063-.035 6.49-3.49 14.15-.053h.006l25.471 12.73c.33.154.514.256.523.262a.15.15 0 0 1-.071.28zM14.6 39.847l23.862 11.927c4.975-1.993 9.681-1.285 12.66-.396L28.22 39.93c-6.654-2.98-12.354-.678-13.62-.086z"
            />
            <path
              id="guide-book-Vector_36"
              fill="#B0906B"
              d="M34.98 39.614a.15.15 0 0 1-.147-.117l-.692-2.977a.15.15 0 0 1 .06-.16.14.14 0 0 1 .167 0l3.72 2.521a.147.147 0 0 1 .038.208.146.146 0 0 1-.206.039l-3.405-2.305.605 2.605a.15.15 0 0 1-.11.18q-.02.002-.034.003z"
            />
            <path
              id="guide-book-Vector_37"
              fill="#B0906B"
              d="M43.676 44.234h-.027a.145.145 0 0 1-.122-.13c-.003-.03-.361-2.995-1.432-3.802a.85.85 0 0 0-.659-.18c-.495.077-.62.398-.638.652-.038.577.406 1.29.898 1.434.077.023.125.106.098.182a.147.147 0 0 1-.185.097c-.62-.182-1.16-1.027-1.109-1.737.036-.504.36-.84.892-.922.316-.047.614.033.885.236.907.68 1.327 2.62 1.48 3.528l1.21-2.42a.15.15 0 0 1 .2-.069.146.146 0 0 1 .068.198l-1.422 2.847a.15.15 0 0 1-.134.083z"
            />
            <path
              id="guide-book-Vector_38"
              fill="#B0906B"
              d="M51.079 48.184a.14.14 0 0 1-.125-.068.145.145 0 0 1 .047-.203c.95-.592 1.398-1.386 1.2-2.125-.136-.512-.571-.883-1.053-.904-.6-.018-1.138.47-1.466 1.366-.024.062-.078.106-.149.097a.15.15 0 0 1-.137-.112l-.524-2.143-.796 1.699a.147.147 0 0 1-.196.07.144.144 0 0 1-.072-.194l.974-2.084a.16.16 0 0 1 .15-.085c.062.005.115.05.13.111l.519 2.123c.533-1.063 1.272-1.16 1.581-1.142.614.026 1.16.488 1.329 1.121.232.869-.262 1.784-1.329 2.45a.16.16 0 0 1-.08.023z"
            />
            <path
              id="guide-book-Vector_39"
              fill="#E0D4C6"
              d="M36.228 34.794a.13.13 0 0 1-.057-.012c-.074-.033-.113-.119-.08-.193.02-.05 2.165-5.008 8.567-6.819a.15.15 0 0 1 .185.101.15.15 0 0 1-.101.184c-6.256 1.77-8.353 6.6-8.374 6.647a.15.15 0 0 1-.137.092z"
            />
            <path
              id="guide-book-Vector_40"
              fill="#E0D4C6"
              d="M39.173 36.133a.149.149 0 0 1-.137-.205c.02-.048.5-1.187 1.757-2.573 1.159-1.276 3.223-2.999 6.476-3.977.077-.024.16.02.184.098a.15.15 0 0 1-.098.184c-3.181.955-5.2 2.639-6.332 3.88-1.228 1.347-1.71 2.486-1.713 2.498a.15.15 0 0 1-.137.092z"
            />
            <path
              id="guide-book-Vector_41"
              fill="#E0D4C6"
              d="M43.726 37.94a.13.13 0 0 1-.057-.011.15.15 0 0 1-.08-.195c.02-.051 2.157-5.111 7.566-6.484.08-.02.161.027.182.108a.15.15 0 0 1-.107.183c-5.26 1.336-7.343 6.259-7.364 6.307a.15.15 0 0 1-.138.093z"
            />
            <path
              id="guide-book-Vector_42"
              fill="#E0D4C6"
              d="M46.536 39.213a.13.13 0 0 1-.06-.012.15.15 0 0 1-.076-.197c.02-.047 2.147-4.793 7.635-6.214.08-.02.16.027.18.108.021.08-.026.16-.106.181-5.343 1.382-7.415 6-7.436 6.044a.15.15 0 0 1-.137.09"
            />
            <path
              id="guide-book-Vector_43"
              fill="#E0D4C6"
              d="M51.089 41.89a.148.148 0 0 1-.134-.214c.024-.046 2.399-4.825 7.347-6.805a.15.15 0 0 1 .193.084.15.15 0 0 1-.083.192c-4.839 1.936-7.169 6.613-7.19 6.66a.15.15 0 0 1-.133.084"
            />
            <path
              id="guide-book-Vector_44"
              fill="#E0D4C6"
              d="M53.633 43.628a.13.13 0 0 1-.057-.011c-.074-.033-.113-.119-.08-.193.024-.053 2.306-5.39 7.694-7.084a.15.15 0 0 1 .188.098.15.15 0 0 1-.099.187c-5.254 1.652-7.488 6.861-7.51 6.914a.15.15 0 0 1-.136.092z"
            />
            <path
              id="guide-book-Vector_45"
              fill="url(#guide-book-paint12_linear_16538_41536)"
              d="m34.338 63.716 40.839-20.415v-1.009c-5.92.34-18.012 3.713-20.916 10.455-5.305-2.178-15.357 3.817-19.923 9.96z"
            />
            <path
              id="guide-book-Vector_46"
              fill="#000"
              d="M34.352 63.917a.15.15 0 0 1-.078-.024.15.15 0 0 1-.071-.125v-1.01a.14.14 0 0 1 .03-.09c2.282-3.075 5.924-6.124 9.742-8.157 4.116-2.193 7.743-2.872 10.24-1.922 3.02-6.693 15.138-10.096 21.004-10.43a.14.14 0 0 1 .11.041.15.15 0 0 1 .047.108v1.01a.15.15 0 0 1-.083.134l-40.876 20.45a.13.13 0 0 1-.066.015m.148-1.109v.718l40.579-20.3v-.757c-5.898.384-17.807 3.77-20.65 10.374a.147.147 0 0 1-.193.077c-5.103-2.098-15.1 3.678-19.736 9.888"
            />
            <path
              id="guide-book-Vector_47"
              fill="#000"
              d="M34.334 63.917a.2.2 0 0 1-.066-.015L8.243 50.898a.15.15 0 0 1-.083-.134v-1.01a.16.16 0 0 1 .03-.089c.693-.93 1.518-1.87 2.462-2.797l-.069-.035a.16.16 0 0 1-.08-.11.14.14 0 0 1 .041-.129c.01-.008.89-.89 2.323-2.022l-.911-.456a.15.15 0 0 1-.08-.104.15.15 0 0 1 .035-.128c.015-.018 1.486-1.644 4.064-3.014l-1.816-.908a.15.15 0 0 1-.084-.132c0-.056.03-.107.078-.134.062-.035 6.406-3.443 14.003-.128.072-.288.182-.607.33-.944 1.183-3.261 5.076-11.184 15.609-14.135a.17.17 0 0 1 .107.009L68.67 36.78c.056.03.09.092.08.157a.15.15 0 0 1-.125.125q-.263.04-.553.117l4.015 2.007c.063.03.093.098.078.167a.15.15 0 0 1-.14.116c-.506.015-1.036.057-1.58.125l3.375 1.689a.15.15 0 0 1 .078.173c0 .009-.007.018-.013.026l1.409.703c.05.024.083.078.083.134v1.01a.15.15 0 0 1-.083.134L34.402 63.902a.13.13 0 0 1-.066.015zM8.458 50.672l25.876 12.93 40.742-20.364v-.825l-1.774-.888a.15.15 0 0 1-.077-.173q.002-.014.012-.03l-3.358-1.676a.15.15 0 0 1-.08-.155.15.15 0 0 1 .124-.125c.518-.08 1.027-.137 1.516-.17l-3.85-1.924a.15.15 0 0 1-.08-.146.15.15 0 0 1 .104-.131q.272-.084.53-.146L44.116 24.787C33.756 27.714 29.928 35.512 28.76 38.73a5.4 5.4 0 0 0-.355 1.073.15.15 0 0 1-.077.104.14.14 0 0 1-.128.003c-6.666-2.988-12.372-.682-13.64-.087l1.81.906a.15.15 0 0 1 .083.134.15.15 0 0 1-.08.134c-2.233 1.138-3.671 2.502-4.1 2.94l.94.47a.15.15 0 0 1 .081.12.14.14 0 0 1-.056.13 32 32 0 0 0-2.331 1.999l.068.036c.042.02.075.062.08.11a.16.16 0 0 1-.044.131c-.98.95-1.837 1.912-2.548 2.868v.867z"
            />
            <path
              id="guide-book-Vector_48"
              fill="#000"
              d="M54.271 52.934a.2.2 0 0 1-.065-.015L28.193 39.897a.146.146 0 0 1-.065-.2.145.145 0 0 1 .2-.066L54.34 52.654a.146.146 0 0 1 .065.2.15.15 0 0 1-.134.083z"
            />
          </g>
        </g>
      </>
    </svg>
  )
}
